import Decimal from 'decimal.js'
import { receiptStates } from '@/modules/base/util/constants'

const { OPEN, PAID, PARTIALLYPAID } = receiptStates

const getStateAndOutstandingAmount = (
  newBookings,
  priceTotal,
  isExpenseType: boolean = false,
): { outstandingAmount: number, state: string } => {
  const outstandingAmount = newBookings.reduce((outstandingAmount, booking) => {
    const { assignments } = booking
    const amount = assignments.reduce((amount, assignment) => {
      return new Decimal(amount).plus(assignment.amount).toDP(2).toNumber()
    }, 0)

    // Handle the sign of assignment amounts based on transaction type:
    // - For expense types: assignment amounts are negative, so we add them to reduce outstanding
    // - For revenue types: assignment amounts are positive, so we subtract them to reduce outstanding
    // - For backward compatibility: if no boolean provided, assume positive amounts (subtract)
    let adjustment: number
    if (isExpenseType) {
      // For expense types, assignment amounts are negative, so adding them reduces outstanding
      adjustment = amount
    } else {
      // For revenue types or default case, assignment amounts are positive, so subtracting them reduces outstanding
      adjustment = -amount
    }

    return new Decimal(outstandingAmount).plus(adjustment).toDP(2).toNumber()
  }, priceTotal)

  let state = OPEN
  if (outstandingAmount > 0 && outstandingAmount < priceTotal) {
    state = PARTIALLYPAID
  } else if (outstandingAmount <= 0) {
    state = PAID
  } else {
    state = OPEN
  }

  return { outstandingAmount, state }
}

export default getStateAndOutstandingAmount
